var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tour-guide',{attrs:{"tour":_vm.tour,"is-expert":_vm.isExpert,"trip-id":_vm.tour.id}}),(!_vm.isExpert)?_c('tour-travel-expert',{attrs:{"expert-data":_vm.tour.expert_data,"tour-name":_vm.tour.name,"trip-id":_vm.tour.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }